(function () {
    'use strict';
    angular.module('tmx-app').controller('PrintCtrl', ['$scope', '$mdDialog', '$window', 'page', 'data', 'CustomerId', 'ProductName', 'ProductId', 'CustomerName','isGuarantorTabDynamic', 'getVisibleValue', 'cacheStore', 'tmxUtility', 'lookupService','TMX_FINANCE_CONSTANTS',

        function printCtrl($scope, $mdDialog, $window, page, data, CustomerId, ProductName, ProductId, CustomerName,isGuarantorTabDynamic, getVisibleValue, cacheStore, tmxUtility, lookupService,TMX_FINANCE_CONSTANTS) {
            $scope.pages = page;
            $scope.applicationData = data;
            $scope.CustomerId = CustomerId;
            $scope.ProductName = ProductName;
            $scope.ProductId = ProductId;

            $scope.CustomerName = CustomerName;
            $scope.getVisibleValue = getVisibleValue;
            $scope.checkTabPermission = tmxUtility.checkTabPermission;
            $scope.checkPermission = tmxUtility.checkPermission;
            $scope.formatDate=tmxUtility.formatDateForCompany;
            var vitasTenants = ["vitas", "vitas-eg"];
            if ($scope.applicationData.AccountApplicationId && $scope.applicationData.AccountApplicationId > 0) {
                $scope.ApplicationType = "Account";

            }
            else {
                $scope.ApplicationType = "Loan";
            }
            var culture = localStorage.getItem('culture');

            $scope.direction = culture == "ar" ? "rtl" : "ltr";

            if (angular.isDefined($scope.pages) && angular.isDefined($scope.pages.tabs) && $scope.pages.tabs.length > 0) {
                if ($scope.direction == "rtl") {
                    $scope.pages.tabs = $scope.pages.tabs.reverse();
                }
            }

            var LoggedInTenant = "";
            var HIDE_PRINT_TAB = ""
            var hiddenTabIndexes = [];
            $scope.tenantName = "";
            //$scope.lookups = lookups;
            var exists = tmxUtility.exists;
            var resolveAttr = tmxUtility.resolveAttr;
            var LoggedInUserConfigurations = cacheStore.get("Configurations");
            if (LoggedInUserConfigurations) {
                LoggedInTenant = LoggedInUserConfigurations.filter(function (item) {
                    return item.ConfigurationKey == 'INTEGRATION_TENANT';
                })[0];
                $scope.tenantName = LoggedInTenant.ConfigurationValue;
            }
            if (LoggedInUserConfigurations) {
                HIDE_PRINT_TAB = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'HIDE_PRINT_TAB', false, $scope.ProductId);
                hiddenTabIndexes = HIDE_PRINT_TAB.split(',');
            }

            $scope.isLebanonTenant = (LoggedInTenant.ConfigurationValue.toLowerCase() == TMX_FINANCE_CONSTANTS.TENANTS.VITAS_LEB);
            //$scope.historyFields = formatHistory($scope.history);

            $scope.isDynamicPage = function (tab) {
                if(tab == 'Guarantors' || tab.defaultValue == 'Guarantors') {
                    return isGuarantorTabDynamic;
                }

                var staticPages = ['CheckEligibility', 'NadraVerisys', 'LocationTracking'];
                return staticPages.indexOf(tab.defaultValue) > -1 ? false : true;
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.hasValue = function (value) {
                if (!angular.isDefined(value) || value == 0 || value == null) {
                    return false;
                }
                return true;
            }
            $scope.returnDirection = function () {
                if ($scope.direction == 'rtl')
                    return true;
                else
                    return false;
            }
            $scope.getPrint = function () {
                if ($scope.direction == 'rtl')
                    return true;
                else
                    return false;
            }
            page = angular.copy($scope.page);
            $scope.print = function () {

                var mywindow = $window.open('', 'PRINT', 'height=900,width=900');
                mywindow.document.write(`
                <html>
                    <head><title>Print Of `+ $scope.ApplicationType + ` Information</title>
                    <style>
         .k-grid-add{
            display: none;
            }
        .k-header{
           font-size:18px;
           font-weight:bold;
           border:2.8px;
            }
          .k-pager-wrap{
              display: none;
          }
           .k-grid-pager{
              display: none;
          }
          .k-grid-delete{
              display: none;
          }
          .k-grid-edit{
              display: none;
          }
          .grid-refresh-button{
           display: none;
       }
       
.betatable table{
border-collapse: collapse;
width:98%
}
.tableclass {
   width:auto;
   page-break-inside:auto;
   page-break-after:auto
 }
/* .lastchild td:last-child,th:last-child {
   display:none
 } */

 .largeWidth {
   width: 100%;
}

.smallWidth {
   width: 48%;
}

.rtlClass{
   direction:rtl;
   text-align:right;
}

.rtlClass md-tabs {
   direction:rtl;
   text-align:right;
}

.rtlClass md-tabs-wrapper {
   direction:rtl;
   text-align:right;
}

.rtlClass md-tabs-wrapper md-tab-data {
   direction:rtl;
   text-align:right;
   
}

.rtlClass md-tabs-wrapper md-tab-data md-tab {
   direction:rtl;
   text-align:right;
   
}

.rtlClass md-tabs-wrapper md-tab-data md-tab-item {
   direction:rtl;
   text-align:right;
}

.pdf-label-div
{
   padding-left: 10px;
   width: 48%;
   background: white;
   /* float: left; */
}

.pdf-heading
{
   border-top: #E0E0E0 1px solid;
   border-bottom: #E0E0E0 1px solid;
   background-color: #F5F5F5;
   width: 100%;
   height: 40px;
   line-height: 40px;
   display: grid;
}

table
{
   width: 100%;
}

.pdf-main-table td
{
   border: 1px solid;
}
.table-top-heading
{
   text-align: center;height: 25px;background: #c4c4c4;
}
.table-date-heading
{
   text-align: center;height: 25px;background: #c4c4c4;
}
.table-signature-heading
{
   text-align: center;height: 25px;background: #c4c4c4;
}
.signature-space
{
   height: 150px;
}
.pdf-main-table{
   width: 100%;
}

.pdf-popup-field
{
   padding: 0 10px; float:left;width: 48%;
}

div>label>b
{
   display: inline-flex;
}

.tmxlogo
{
   width: 100%;
}

.tab-title
{
   line-height: 40px;
   border-top: #E0E0E0 1px solid !important; 
   border-bottom: #E0E0E0 1px solid !important; 
   background-color: #F5F5F5 !important;
   width:100%;padding:0px 10px 0px 10px;
   -webkit-print-color-adjust: exact;
   display:table;

}

.samba-tab-title
{
   line-height: 40px;
   border-top: #E0E0E0 1px solid !important; 
   border-bottom: #E0E0E0 1px solid !important; 
   background-color: #04509c !important;
   width:100%;padding:0px 10px 0px 10px;
   -webkit-print-color-adjust: exact;
}

.samba-tab-title b{
   color: white !important;
}

@media print{
   .samba-tab-title b{
       color: white !important;
   }
}

.header-field
{
   border-top: 1px dotted;
   border-bottom: 1px dotted;
   width: 100%;
}
                    </style>                                 
                    </head>
                <body style="height:auto;direction:`+ $scope.direction + `" onload="window.print()">`


                );

                // assets/images/TmX-DLP-themeGreen.png
                if (vitasTenants.indexOf(LoggedInTenant.ConfigurationValue.toLowerCase()) == -1 && exists(APP_CONSTANTS.tenantLogo)){ // Exclude logo for vitas
                    mywindow.document.write('<div><img class="tmxlogo" src="' + APP_CONSTANTS.tenantLogo + '" alt="logo"></img></div>');
                }
                mywindow.document.write('<div><h1 style="display:inline;">Print Of ' + $scope.ApplicationType + ' Information</h1></div>');

                mywindow.document.write('<div><span>Customer:</span>' + $scope.CustomerId + '</span> | Customer Name:' + $scope.CustomerName + '</span> ');
                var printContents = document.getElementById("testPrint").innerHTML;
                mywindow.document.write(printContents);
                mywindow.document.write(`
    <style>
    .beta th, td {
      border-style: solid;
      font-size:15px;
    }
    </style>
        </body></html>`);
                // mywindow.document.write('</div>');
                // window.print();
                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus();

            }
            $scope.getModel = function (rc) {
                // var rowIdentifier= rc.table.replace("Tmx","")+"Id";

                var rowIdentifier = "";
                if (rc.table.lastIndexOf('.') > 1) {
                    rowIdentifier = rc.table.substr(rc.table.lastIndexOf('.') + 1).replace("Tmx", "") + "Id";
                }
                else {
                    rowIdentifier = rc.table.replace("Tmx", "") + "Id";
                }


                var model = {
                    id: rowIdentifier,
                    fields: {}
                };
                function makeModelObj(field) {
                    model.fields[field.name] = {};
                    model.fields[field.name]["type"] = field.type;
                    model.fields[field.name]["validation"] = {};
                    //if(model.fields[field.name]["type"]=='select') model.fields[field.name]["type"]="number";
                    //Set validations for the field
                    //1- Set required for all kinds
                    if (resolveAttr(field, "validations.required") == 'true') {
                        model.fields[field.name].validation.required = true;
                    }
                    //2- For numbers set min and max if any
                    if (field.type == 'number' || field.type == 'numeric') {
                        if (exists(field, "validations.maxlength") && !isNaN(field.validations.maxlength.value)) {
                            model.fields[field.name].validation.max = field.validations.maxlength.value;
                        }
                        if (exists(field, "validations.minlength") && !isNaN(field.validations.minlength.value)) {
                            model.fields[field.name].validation.min = field.validations.minlength.value;
                        }
                    }
                }
                rc.columns.forEach(makeModelObj);
                model.fields[rowIdentifier] = { type: "number" };
                return model;
            }
            $scope.optionValue = function (value, ary, label) {
                for (var i = 0; i < ary.length; i++) {
                    if (value == ary[i].LookupId) {
                        return ary[i].VisibleValue;
                    }
                }
                if (label == 'Currency') {
                    return 'PKR';
                }
                return '';
            }

            $scope.getLookupValueById = function (lookupId) {
                var lookupRow = lookupService.getLookupById(lookupId);
                if (lookupRow) {
                    return lookupRow.VisibleValue;
                }
                else {
                    return lookupId;
                }

            }          

            $scope.showFieldDiv = function (field) {
                if ($scope.isTextBox(field) || $scope.isSelect(field) || $scope.isDate(field) || $scope.isTable(field) || $scope.isImage(field) || $scope.isHeader(field)) {
                    return true;
                }
                else {
                    return false;
                }
            }

            $scope.isTextBox = function (field) {

                if ((field.type == "text" || field.type == "alphanumeric" || field.type == "number" || field.type == "numeric" || field.type == "textarea" || field.type == "cnic" || field.type == "phone" || field.type == "amount") && exists(field.form_name)) {
                    // if (field.type == "numeric") {
                    //     field.type = "number";
                    // }
                    if (field.name == "FamilyIdentifier" || field.name == "OtherAssetDetails") {
                        field.type = "alphanumeric";
                    }

                    return true;
                }
                return false;

            }
            $scope.isTabApplicable = function (tab) {
                return hiddenTabIndexes.indexOf("" + tab.id) < 0; //need to return false where tab is not in hidden tabs
            }
            $scope.isDate = function (field) {
                return (field.type == "date") && exists(field.form_name);
            }
            $scope.isCheckbox = function (field) {
                return (field.type == "checkbox") && exists(field.form_name);
            }
            $scope.isTable = function (field) {
                if (field.type == "table" && exists(field.form_name)) {

                    if (field.gridOptions && field.gridOptions.columns) {
                        var columns = [];
                        for (var i = 0; i < field.gridOptions.columns.length; i++) {
                            if (field.gridOptions.columns[i].label != "CreatedBy" && field.gridOptions.columns[i].label != "CreatedDate" && field.gridOptions.columns[i].label != "Customer Introducer Id" && field.gridOptions.columns[i].label != "Other Outstanding Loan Detail ID" && field.gridOptions.columns[i].label != "CustomerIntroducerId" && field.gridOptions.columns[i].label != "OtherOutstandingLoanDetailID")
                                columns.push(field.gridOptions.columns[i]);
                        }
                        field.gridOptions.columns = columns;
                    }
                }
                return (field.type == "table") && exists(field.form_name);
            }
            $scope.isHeader = function (field) {
                return (field.type == "header");
            }
            $scope.isSelectfield = function (field) {
                if (field.type == "select" && angular.isDefined(field.options) && angular.isDefined(field.options.value)) {

                    if (field.options && field.options.value) {
                        let lkpVisibleValue = "";
                        field.options.value.forEach(e => {
                            if (e.LookupId.toString() == field.value || e.VisibleValue == field.value){ // since the function is calling itself again and again therefore we had to check visible value as well
                                lkpVisibleValue = e.VisibleValue;
                            }
                        });

                        field.value = lkpVisibleValue;
                    }

                    return (field.type == "select") && exists(field.form_name);
                }
            }

            $scope.isSelect = function (field) {
                return (field.type == "select") && exists(field.form_name);

            }
            $scope.showSignature = function () {
                if (vitasTenants.indexOf(LoggedInTenant.ConfigurationValue.toLowerCase()) > -1)
                    return true;
                else
                    return false;
            }
            $scope.isImage = function (field) {
                if (field.type == "checkbox" || field.type == "fingerprint" || field.type == "signature") {
                    if (field.value) {
                        if (field.value.indexOf('.jpg') > -1 || field.value.indexOf('.png') > -1) {
                            field.fileURL = field.value;
                            return true;
                        }
                    }

                    if (field.attachment) {
                        if (field.attachment.indexOf('data:image/jpeg;base64') > -1) {
                            // $scope.fileURL  = $scope.attachment;
                            field.fileURL = field.attachment;
                            return true;
                        }
                    }

                    return false;
                }


            }
        }]);
})();